import { Link } from 'react-router-dom';
import styled from 'styled-components';

import navbarBackground from '../../assets/images/navbarBackground.svg';

import HamburgerButton from './HamburgerButton';
import NavigationMenu from './NavigationMenu';

export const NavBarContainer = styled.div<{ $isFixed: boolean }>`
	width: 100%;
	background-image: url("${navbarBackground}");
	background-size: contain;
	background-position: center;
	background-repeat: repeat-x;

	position: ${(props) => (props.$isFixed ? 'fixed' : 'sticky')};
	top: ${(props) => (props.$isFixed ? '0' : '6vh')};
	z-index: 1000;

	@media (max-width: 1102px) {
		background-size: cover;
	}
`;

export const NavBarContainerBackground = styled.div<{ $isFixed: boolean }>`
	width: 100%;
	height: 50%;
	background-color: ${(props) =>
		props.$isFixed ? '#41588a' : 'transparent'};
	transition-property: background-color;
	transition-duration: 0.05s;
	transition-timing-function: ease-in-out;

	position: absolute;
	z-index: -1;
`;

export const NavBar = styled.div`
	width: 100%;
	margin: 0 auto;
	padding: 4px 48px;

	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;

	@media (min-width: 997px) {
		padding: 4px 80px;
	}

	@media (max-width: 520px) {
		padding: 4px 9vw;
	}
`;

export const LogoContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	cursor: pointer;
`;

export const StyledLogo = styled.img<{ $isFixed: boolean }>`
	height: 48px;
	width: 48px;
	transform: ${(props) =>
		props.$isFixed
			? 'scale(1.5) rotate(-12deg) translate(-16px, 16px)'
			: 'scale(1.4)'};
	transition: transform 0.18s ease-in-out;
	will-change: transform;

	@media (max-width: 520px) {
		height: auto;
		width: 9vw;
	}
`;

export const StyledTitleImage = styled.img<{ $isFixed: boolean }>`
	width: 190px;
	transform: ${(props) => (props.$isFixed ? 'translateY(-3px)' : 'none')};
	transition: transform 0.18s ease-in-out;
	will-change: transform;

	@media (max-width: 520px) {
		position: absolute;
		left: 50%;
		width: 35vw;
		transform: ${(props) =>
			props.$isFixed ? 'translate(-50%, -3px)' : 'translateX(-50%)'};
	}
`;

export const StyledUL = styled.ul<{ $isFixed: boolean }>`
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	align-items: center;
	gap: 3vw;
	transform: ${(props) => (props.$isFixed ? 'translateY(-3px)' : 'none')};
	transition: transform 0.18s ease-in-out;
	will-change: transform;

	@media (max-width: 996px) {
		display: none;
	}
`;

export const StyledLink = styled(Link)`
	color: #c7d4d6;
	font-weight: 500;
	text-decoration: none;
	transition: color 0.2s ease;

	&:hover {
		color: #ffffff;
	}
`;

export const MenuWrapper = styled.div`
	position: relative;
	display: none;

	@media (max-width: 996px) {
		display: inline-block;
	}
`;

export const StyledHamburgerButton = styled(HamburgerButton)`
	display: none;

	@media (max-width: 996px) {
		display: block;
	}
`;

export const StyledNavigationMenu = styled(NavigationMenu)<{ $isOpen: boolean }>`
	position: absolute;

	top: calc(100% + -2px);
	right: -48px;
	opacity: ${(props) => (props.$isOpen ? 1 : 0)};
	transform: translateY(${(props) => (props.$isOpen ? '0' : '-10px')});
	pointer-events: ${(props) => (props.$isOpen ? 'auto' : 'none')};
	transition: opacity 0.2s ease, transform 0.2s ease;
	will-change: transform, opacity;

	@media (max-width: 520px) {
		right: -9vw;
	}
`;

export const StyledNav = styled.nav`
	display: flex;
	align-items: center;
`;
